import {Language, DEFAULT_LANGUAGE} from 'constants/language';
import {RecursivePartial} from 'types';

import {TranslationKeys} from '../translation-keys.type';

import ar from './ar.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import he from './he.json';
import pt from './pt.json';

type DefaultLangName = typeof DEFAULT_LANGUAGE;
type NonDefaultLanguages = Exclude<Language, DefaultLangName>;

type Languages = ({name: DefaultLangName, translation: TranslationKeys} |
    {name: NonDefaultLanguages, translation: RecursivePartial<TranslationKeys>})[];

const languages: Languages = [
    {name: Language.Arabic, translation: ar},
    {name: Language.English, translation: en},
    {name: Language.Spanish, translation: es},
    {name: Language.French, translation: fr},
    {name: Language.Hebrew, translation: he},
    {name: Language.Portuguese, translation: pt},
];
export default languages;
